import { getBetSelectionList } from '@tickets/helpers';

export const copyEvents = async (ticket, boostedOddsGameIds) => {
  const selections = await getBetSelectionList(ticket);

  return selections.reduce((acc, selection, ind) => {
    const data = {
      ...acc,
      [selection.id]: {
        game: selection.game,
        market: selection.market,
        event: selection,
        isBanker: ticket.dataFromSwarm.selection_list.find((item) => item.selection_id === selection.id)?.is_banker,
        isBoosted: boostedOddsGameIds[selection.game.id]?.some((item) => item.Id === selection?.id),
      },
    };

    if ([31, 184].includes(selection.sport.id)) {
      data[selection.id] = {
        ...data[selection.id],
        game: {
          ...data[selection.id].game,
          regionId: selection.region.id,
          competitionId: selection.competition.id,
        },
        event: {
          ...data[selection.id].event,
          isRacingEvent: true,
          racingType: selection.sport.id,
          sp: !selection.price,
          eventOption: ind + 1,
          marketType: ticket.dataFromSwarm.type_id >= 40 && ticket.dataFromSwarm.type_id <= 42 ? 2 : 3,
        },
      };
    }

    return data;
  }, {});
};
